/* MavoStudio – Farbcodes & 3D-Bühne für die Konfiguratoren (assets/mavo-designer.js = Untersetzer, assets/mavo-chess.js = Schachbrett)
   - glatte Farben: Produkt-Metafeld „Farbcodes“ → sonst aus dem Kachelfoto gemessen → sonst Notfall-Farbe
   - 3D-Bühne oben in der Galerie: ersetzt die beiden Farbbilder (.mavo-color-preview), lädt assets/mavo-coaster-3d.js */
if (!window.mavoColors) {
  // Notfall-Farben, falls ein Foto nicht gemessen werden kann
  const FALLBACK = {
    'off-white': '#e4dcc4', weiß: '#f1f0ea', cream: '#e6d6b0', schwarz: '#202022', aperoli: '#e2601e', orange: '#ec7d2c',
    gelb: '#eec34a', rosa: '#e39aaa', berry: '#93263a', bordeaux: '#6a1f2a', lila: '#74326a', perry: '#8d9ad2',
    hellblau: '#a8c6e4', königsblau: '#1f4fc1', lapislazuli: '#1d3a8a', eukalyptus: '#9cb7a6', matcha: '#8ea866',
    dunkelgrün: '#1d4a32', taupe: '#7d7262', coffee: '#4e2a24', chili: '#ad0000', lavendel: '#a27b92',
  };
  const listeners = new Set();
  const changed = () => listeners.forEach((fn) => fn());
  const designer = () => document.querySelector('[data-mavo-designer]');

  // Metafeld „Farbcodes“, eine Zeile pro Farbe: „Cream: #e6d6b0“
  let overrides = null;
  const override = (name) => {
    if (!overrides) {
      overrides = {};
      const root = designer();
      (root ? root.dataset.hex || '' : '').split(/[\n;]/).forEach((line) => {
        const m = /^\s*(.+?)\s*[:=]\s*(#[0-9a-f]{3,8})\s*$/i.exec(line);
        if (m) overrides[m[1].toLowerCase()] = m[2];
      });
    }
    return overrides[String(name).toLowerCase()];
  };

  // Durchschnittsfarbe aus der Mitte des Kachelfotos (gleicher Ausschnitt wie snippets/mavo-tile-crop.liquid)
  const measured = new Map();
  const measure = (url, size, pos) => {
    const key = `${url}|${size}|${pos}`;
    if (measured.has(key)) return measured.get(key);
    measured.set(key, null);
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      try {
        const S = parseFloat(size) || 100;
        const [px, py] = (pos || '50% 50%').split(' ').map((v) => parseFloat(v) / 100);
        const wx = 100 / S, wy = wx * (img.naturalWidth / img.naturalHeight);
        const sw = wx * img.naturalWidth, sh = wy * img.naturalHeight;
        const sx = px * (1 - wx) * img.naturalWidth, sy = py * (1 - wy) * img.naturalHeight;
        const ctx = document.createElement('canvas').getContext('2d', { willReadFrequently: true });
        ctx.canvas.width = ctx.canvas.height = 8;
        ctx.drawImage(img, sx + sw * 0.2, sy + sh * 0.2, sw * 0.6, sh * 0.6, 0, 0, 8, 8);
        const d = ctx.getImageData(0, 0, 8, 8).data;
        let r = 0, g = 0, b = 0;
        for (let i = 0; i < d.length; i += 4) { r += d[i]; g += d[i + 1]; b += d[i + 2]; }
        const hex = (v) => Math.round(v / 64).toString(16).padStart(2, '0');
        measured.set(key, `#${hex(r)}${hex(g)}${hex(b)}`);
      } catch (error) {
        measured.set(key, '');
      }
      changed();
    };
    img.onerror = () => { measured.set(key, ''); changed(); };
    img.src = url;
    return null;
  };

  // Farbcode einer Farbe: Metafeld → gemessen → Notfall-Farbe; null = wird noch gemessen
  const hexFor = (name, url, size, pos) => {
    if (!name) return null;
    const fixed = override(name);
    if (fixed) return fixed;
    if (!url) return FALLBACK[String(name).toLowerCase()] || null;
    const m = measure(url, size, pos);
    if (m === null) return null;
    return m || FALLBACK[String(name).toLowerCase()] || null;
  };

  const solid = (hex) => `linear-gradient(${hex}, ${hex})`;

  // Original-Foto eines Farbfelds merken, bevor es auf die glatte Farbe umgestellt wird
  const source = (element) => {
    if (!element.dataset.src) {
      const match = /url\((['"]?)(.*?)\1\)/.exec(element.style.backgroundImage || '');
      element.dataset.src = match ? match[2] : '';
      element.dataset.size = element.style.getPropertyValue('--mavo-size').trim();
      element.dataset.pos = element.style.getPropertyValue('--mavo-pos').trim();
    }
    return { url: element.dataset.src, size: element.dataset.size || '', pos: element.dataset.pos || '' };
  };

  // Farbfeld/Palettenstein auf den glatten Farbcode umstellen
  const flatten = (element, name) => {
    const { url, size, pos } = source(element);
    const hex = hexFor(name, url, size, pos);
    if (hex) element.style.backgroundImage = solid(hex);
  };

  // Name → Farbcode + Foto (über das Farbfeld in der Farbauswahl)
  const infoFor = (name) => {
    const button = Array.from(document.querySelectorAll('[data-mavo-color]')).find((b) => name && b.dataset.mavoColor === name);
    const dot = button && button.querySelector('.mavo-color__dot');
    const { url, size, pos } = dot ? source(dot) : { url: '', size: '', pos: '' };
    return { name, url, size, pos, hex: hexFor(name, url, size, pos) };
  };

  // ---------- 3D-Bühne ----------
  const ensureStage = () => {
    let stage = document.querySelector('[data-mavo-stage]');
    if (stage || !designer()) return stage;
    const preview = document.querySelector('media-gallery .mavo-color-preview');
    if (!preview) return null;
    stage = document.createElement('div');
    stage.className = 'mavo-stage';
    stage.setAttribute('data-mavo-stage', '');
    stage.setAttribute('role', 'region');
    stage.setAttribute('aria-label', designer().dataset.stageLabel || 'Dein Untersetzer in 3D');
    stage.innerHTML = '<p class="mavo-stage__loading">3D wird geladen …</p>';
    preview.replaceWith(stage);
    return stage;
  };

  // 3D erscheint (wie vorher die beiden Farbbilder), sobald eine Farbe gewählt wurde
  const mountStage = async () => {
    const stage = ensureStage();
    const root = designer();
    if (!stage || !root || !window.mavoDesigner || stage.dataset.mounted) return;
    if (!document.body.classList.contains('mavo-colors-selected')) return;
    stage.dataset.mounted = 'true';
    try {
      const module = await import(root.dataset.viewerUrl);
      // Untersetzer: mountCoaster3D (mavo-coaster-3d.js) · Schachbrett: mountBoard3D (mavo-chess-3d.js)
      await (module.mountBoard3D || module.mountCoaster3D)(stage, {
        threeUrl: root.dataset.threeUrl,
        partsUrl: root.dataset.partsUrl,
        logoUrl: root.dataset.logoUrl,
        api: window.mavoDesigner,
      });
      // Hinweis oben im 3D: bleibt sichtbar, damit klar ist, dass man auch hier Farben legen kann
      const hint = stage.querySelector('.mavo-stage__hint');
      if (hint) {
        hint.innerHTML =
          `<span class="mavo-stage__hint-tap">${root.dataset.stageTap || 'Stein antippen = Farbe wechseln'}</span>` +
          '<span class="mavo-stage__hint-tap" aria-hidden="true"> · </span>' +
          '<span>Wischen zum Drehen</span>';
      }
    } catch (error) {
      console.error('[MAVO 3D]', error);
      stage.dataset.mounted = '';
    }
  };

  // „In 3D drehen“ / Sprung-Button: 3D einblenden und hinscrollen
  const showStage = () => {
    document.body.classList.add('mavo-colors-selected');
    const stage = ensureStage();
    mountStage();
    // nur hinscrollen, wenn die Bühne nicht schon ganz zu sehen ist (am Desktop steht sie links fest)
    if (stage) requestAnimationFrame(() => {
      const box = stage.getBoundingClientRect();
      if (box.top >= 0 && box.bottom <= window.innerHeight) return;
      stage.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    return Boolean(stage);
  };
  new MutationObserver(() => mountStage()).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  // 3D-Dateien schon im Hintergrund laden, damit der Untersetzer nach der ersten Auswahl sofort da ist
  window.addEventListener('load', () => {
    setTimeout(() => {
      const root = designer();
      if (!root) return;
      [root.dataset.threeUrl, root.dataset.viewerUrl, root.dataset.partsUrl, root.dataset.logoUrl, root.dataset.chessPartsUrl].forEach((href) => {
        if (!href) return;
        const link = document.createElement('link');
        link.rel = 'modulepreload';
        link.href = href;
        document.head.append(link);
      });
    }, 1500);
  });

  // Text nur setzen, wenn er sich ändert (sonst melden MutationObserver ständig Änderungen)
  const setText = (element, text) => {
    if (element && element.textContent !== text) element.textContent = text;
  };

  window.mavoColors = {
    hexFor,
    solid,
    source,
    flatten,
    infoFor,
    setText,
    mountStage,
    showStage,
    onChange: (fn) => listeners.add(fn),
  };
}